import StartupsFundraisesInstance from 'modules/startupsFundraises/repository';

export const getFundraise = (fundraise, opts) => StartupsFundraisesInstance.getFundraise(fundraise, opts);

export const postFundraiseInvestment = (fundraise, data) => StartupsFundraisesInstance.postFundraiseInvestment(fundraise, data);

export const putFundraiseInvestment = (fundraise, investment, data) => StartupsFundraisesInstance.putFundraiseInvestment(fundraise, investment, data);

export const deleteFundraiseInvestment = (fundraise, investment) => StartupsFundraisesInstance.deleteFundraiseInvestment(fundraise, investment);

export const getFundraiseInvestments = (fundraise) => StartupsFundraisesInstance.getFundraiseInvestments(fundraise);

export const getFundraiseInvites = (fundraise) => StartupsFundraisesInstance.getFundraiseInvites(fundraise);

export const postFundraiseInvite = (fundraise, data) => StartupsFundraisesInstance.postFundraiseInvite(fundraise, data);

export const deleteFundraiseInvite = (fundraise, invite) => StartupsFundraisesInstance.deleteFundraiseInvite(fundraise, invite);
